var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16699 9.99996C2.16699 5.39163 5.89199 1.66663 10.5003 1.66663C15.1087 1.66663 18.8337 5.39163 18.8337 9.99996C18.8337 14.6083 15.1087 18.3333 10.5003 18.3333C5.89199 18.3333 2.16699 14.6083 2.16699 9.99996ZM13.492 14.1666L14.667 12.9916L11.6753 9.99996L14.667 7.00829L13.492 5.83329L10.5003 8.82496L7.50866 5.83329L6.33366 7.00829L9.32533 9.99996L6.33366 12.9916L7.50866 14.1666L10.5003 11.175L13.492 14.1666Z",
    fill: "#ED4646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewReject);
export default __webpack_public_path__ + "static/media/ReviewReject.74e81d28199a262b7515bb695796ed8f.svg";
export { ForwardRef as ReactComponent };